
import { Spin, Tree, Avatar, Card } from 'antd';
import React from 'react';
import _ from 'lodash';
import { api, app, config } from 'xadmin';
import { formatDepartment } from '../components/util'

const AvatarIcon = (props) => {
  if (props.icon) {
    return <Avatar size={20} shape="square" src={config('mediaUrl') + props.icon} style={{ margin: '0 10px 3px 0' }} />
  } else {
    return <Avatar size={20} shape="square" style={{ margin: '0 10px 3px 0' }}>M</Avatar>
  }
}

const dataFun = (data = [], departmentId) => {
  return data.filter(item => item?.department[0]?.id === departmentId).map(item => ({
    name: item.name,
    id: item.id,
    key: item.id + '_' + Math.random() * 10,
    showicon: true,
    isLeaf: true,
    icon: item.icon || (item.model && item.model.icon),
    isNode: true,
    nodeItem: item
  }))
}

const NodeTree = props => {
  const { model } = props
  const [state, set] = React.useState({
    models: [],
    treeData: [],
    loading: false,
    current: []
  })
  const { models, treeData, loading, current } = state
  const setState = props => set({ ...state, ...props })

  React.useEffect(() => {
    setState({ loading: true })
    const schema = app.get('models')['Department']
    api(schema)
      .query({ fields: ['name', 'parent'] })
      .then(({ items }) => {
        if (items && !_.isEmpty(items))
          setState({
            models: items,
            treeData: formatDepartment(items),
            loading: false
          })
      })
  }, [])

  const loadData = React.useCallback((treeNode) => {
    return new Promise((resolve) => {
      const { dataRef } = treeNode.props
      const parentId = dataRef.nodeKey

      const where = { department: dataRef.id }
      if (model && model.id) {
        where['modelId'] = model
      }
      api(app.get('models').Node)
        .query({ fields: ['modelId', 'icon', 'model.icon', 'department'] }, { where })
        .then(({ items }) => {
          dataRef.children = dataFun(items, dataRef.id)
          setState({})
          resolve()
        })
    })
  })

  const onChange = (selectedKeys, e) => {
    const { dataRef } = e.node.props
    if (dataRef.isNode && dataRef.id) {
      app.go(`/app/model/node/${dataRef.id}/view`)
    }
  }

  const renderTreeNodes = (data, prefix) => {
    if (data && _.isArray(data)) {
      return data.map((item) => {
        if (item.child || item.children) {
          return (
            <Tree.TreeNode
              title={item.name}
              key={item.id + "&" + prefix}
              nodeKey={item.id}
              value={item.id}
              dataRef={item}>
              {item.child ? renderTreeNodes(item.child, prefix ? prefix + '-' + item.id : item.id,) : null}
              {item.children ? renderTreeNodes(item.children, prefix ? prefix + '-' + item.id : item.id,) : null}
            </Tree.TreeNode>
          )
        }
        return (<Tree.TreeNode
          isLeaf={item.isLeaf}
          title={item.name}
          key={item.id + "&" + prefix}
          nodeKey={item.id}
          value={item.id}
          icon={item.showicon ? <AvatarIcon icon={item.icon} /> : ''}
          dataRef={item}>
        </Tree.TreeNode>)
      })
    }
  }

  const dom = models && !_.isEmpty(models) ? (
    <div style={{ height: '100%', overflow: 'auto' }}>
      <Tree showIcon={false} onSelect={onChange} loadData={loadData} >
        {renderTreeNodes(treeData, '')}
      </Tree>
    </div>
  ) : <Spin style={{ width: '100%', marginTop: 20 }} />

  return dom
}

const paramSchema = () => ({
  type: 'object',
  properties: {
    model: {
      title: '模型',
      type: 'object',
      fieldType: 'model',
      properties: {},
    }
  },
  required: [],
  form: ['model',
    '*'
  ]
})

const NodeTreeWidget = {
  title: '资产导航树',
  category: '业务选择器',
  icon: require('../icon/资产导航树.svg'),
  component: NodeTree,
  paramSchema,
  fieldWidget: true
}

export default NodeTreeWidget
